import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'folder-context-menu',
  template: require('./folder.context.menu.html')
})
export class FolderContextMenuComponent implements OnInit {
  @Input() folder: any;
  @Input() elementId: string;

  @Output() onRename = new EventEmitter<any>();
  @Output() onEdit = new EventEmitter<any>();
  @Output() onAdd = new EventEmitter<any>();
  @Output() onMonitor = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  constructor(private window: Window) {}

  ngOnInit() {
  }

  unlockText(): string {
    const folderLockedById = _.get(this.folder, 'lockedBy.id', 0);
    const currentUserId = _.get(this.window, 'currentUser.id', -1);
    return folderLockedById === currentUserId ? 'Unlock Folder' : 'Force Unlock Folder';
  }

  rename() {
    this.onRename.emit(this.folder);
  }

  add() {
    this.onAdd.emit(this.folder);
  }

  edit() {
    this.onEdit.emit(this.folder);
  }

  monitor() {
    this.onMonitor.emit(this.folder);
  }

  delete() {
    this.onDelete.emit(this.folder);
  }
}
